import { setCollect } from '@/services/api';
import { useLockAsyncFn } from '.';

type IProps = {
  onSuccess?: () => void;
};

export const useCollection = (props: IProps = {}) => {
  const { onSuccess } = props;
  const { asyncFn, loading } = useLockAsyncFn(setCollect, {
    onSuccess,
  });

  return {
    onSetCollect: asyncFn,
    loading,
  };
};
